import validateAddress from '@active/core/address/validateAddress';
import countriesConfig from '@active/core/address/countriesConfig';
import { isEmail } from '@active/core/email/validate';
import { objectFilter } from '../../../../../../shared/utils/commonUtils';
import addressFormatter from './addressFormatter';

const maxNameLength = 255;

const nameFormatter = (name) => {
  return name && name.slice(0, maxNameLength);
};

const addressParse = (billingAddress) => {
  const billingInfo = objectFilter(billingAddress);
  const { email, address } = billingInfo;
  try {
    const isValidateEmail = (email && isEmail(email)) || !email; // email is optional
    const isValidateAddress = validateAddress(countriesConfig)(address);
    return isValidateAddress && isValidateEmail ? {
      ...billingInfo,
      address: addressFormatter(address),
    } : undefined;
  } catch {
    return undefined;
  }
};

export const appleAddressParse = (source) => {
  if (!source) {
    return undefined;
  }
  const {
    addressLines = [], administrativeArea,
    countryCode, familyName,
    givenName, locality,
    postalCode,
    subAdministrativeArea, subLocality,
    emailAddress,
  } = source;
  const billingInfo = {
    firstName: nameFormatter(givenName),
    lastName: nameFormatter(familyName),
    email: emailAddress,
    address: {
      country: countryCode ? countryCode.toUpperCase() : undefined,
      stateProvince: administrativeArea,
      'stateProvince.2': subAdministrativeArea,
      city: locality,
      'city.2': subLocality,
      postalCode,
      line1: addressLines[0],
      line2: addressLines[1],
      'line2.2': addressLines[2],
    },
  };
  return addressParse(billingInfo);
};

export const googleAddressParse = (source) => {
  if (!source) {
    return undefined;
  }
  const {
    phoneNumber, address3, address2,
    countryCode, address1, postalCode,
    name = '', locality, administrativeArea,
    email,
  } = source;
  const nameArr = name.split(' ');
  const billingInfo = {
    firstName: nameFormatter(nameArr[0]),
    lastName: nameFormatter(nameArr[nameArr.length - 1]),
    phoneNumber,
    email,
    address: {
      country: countryCode ? countryCode.toUpperCase() : undefined,
      stateProvince: administrativeArea,
      city: locality,
      postalCode,
      line1: address1,
      line2: address2,
      'line2.2': address3,
    },
  };
  return addressParse(billingInfo);
};
